<template>
  <div class="container">
    <Message :show="message.msg" :message="message" />
    <div v-if="total_lines == 0" id="fileform" ref="fileform" class="fileupload container" v-bind:class="getClasses">
      <div id="fileBrowser" class="panel panel-5m" v-bind:class="getCssClass(true)">
          <Label text="Colocar el archivo aqui" header="header-2" />
      </div>
    </div>
    <div class="datatable">
        <DataTable v-if="total_lines > 0" :inputData="recordsData" :fields="fields" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';

import DataTable from './DataTable';
import Message from './Message';
import Label from './Label';

export default {
    name: 'InputForm',
    components: {
        DataTable,
        Label,
        Message
    },
    data: function() {
        return {
            user: {},
            axiosParams: {},
            message: {},
            recordsData: [],
            fields: {
                id: {
                    label: '#',
                    sortable: true,
                    tdClass: 'align-middle'
                },
                rfc: {
                    label: 'R.F.C.',
                    sortable: true,
                    tdClass: 'align-middle'
                },
                name: {
                    label: 'RAZÓN SOCIAL',
                    tdClass: 'align-middle'
                },
                situation: {
                    label: 'SITUACIÓN',
                    sortable: true,
                    tdClass: 'align-middle'
                }
            },
            input_file: '',
            file_size: 0,
            total_lines: 0,
            dragAndDropCapable: true,
            inDragMode: false,
        }
    },
    props: {
        fileName: String
    },
    created: function() {
        this.setData();
    },
    methods: {
        setData: function() {
            var vm = this;
            const lsUser = Vue.localStorage.get('user');
            if (lsUser) {
                vm.user = JSON.parse(lsUser);
                vm.axiosParams = {
                    headers: {
                        'Authorization': vm.user.access.key
                    }
                }
            }
        },
        fileToJSON: async function(txt) {
            var vm = this;
            var lines = txt.split("\n");
            // console.log(this.total_lines);
            var requests = [];
            lines.map(function(line, indexLine) {
                line = line.replace(/[\n\r]+/g, '');
                var obj = {rfc: line};
                requests.push(obj);
            });
            var url = process.env.VUE_APP_HOST + process.env.VUE_APP_PATH_API + 'search';
            vm.recordsData = [];
            vm.total_lines = 0;
            var i = 1;
            await axios.post(url, requests, vm.axiosParams).then(async function(response) {
                response.data.forEach((item) => {
                    var obj = {id: i++, rfc: item.rfc, name: '', situation: ''};
                    if (item.data) {
                        obj.situation = item.data.situation;
                        obj.name = item.data.name;
                        if (item.data.situation === 'Presunto'){
                            obj['_rowVariant'] = 'warning';
                        } else if (item.data.situation === 'Definitivo'){
                            obj['_rowVariant'] = 'danger';
                        } else if (item.data.situation === 'Sentencia Favorable'){
                            obj['_rowVariant'] = 'success';
                        } 
                    }
                    vm.recordsData.push(obj);
                });
                console.log(vm.recordsData);
                vm.total_lines = vm.recordsData.length;
            }).catch(function(error) {
                console.log(error);
                vm.message = {
                    msg: error,
                    variant: "danger",
                    dismiss: 4
                }
                return null;
            });

            // console.log(vm.total_candidates);
            // result.pop(); // remove the last item 
            
        },
        readFile: function() {
            var vm = this;
            vm.total_candidates = 0;
            vm.message = {
                msg: "Leyendo el archivo: " + vm.input_file.name,
                variant: "info",
                dismiss: 6
            }
            var reader = new FileReader();
            vm.file_size = vm.input_file.size;
            reader.readAsText(vm.input_file);
            reader.onload = function(event) {
                var txt = event.target.result;
                vm.fileToJSON(txt);
                vm.message = {}
            };
            reader.onerror = function(evt) {
                if (evt.target.error.page == "NotReadableError") {
                    vm.message = {
                        msg: "No se puede leer el archivo!",
                        variant: "warning",
                        dismiss: 4
                    }
                }
            }
        },
        loadInputFile: function(event) {
            var vm = this;
            if (window.FileReader) {
                vm.input_file = event.target.files[0];
                vm.readFile();
            } else {
                vm.message = {
                    msg: "Operación no soportada por este navegador!",
                    variant: "warning",
                    dismiss: 4
                }
            }
        },        
        getCssClass: function (value) {
            var vm = this;
            if (value) {
                if (vm.inDragMode) 
                    return 'hide';
                else 
                    return '';
            } else {
                if (vm.inDragMode) 
                    return 'showText';
                else 
                    return 'hide';
            }
        }
    },
    mounted: async function() {
        var vm = this;
        // Drag and Drop
        if( vm.dragAndDropCapable ){
        /*
            Listen to all of the drag events and bind an event listener to each
            for the fileform.
        */
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
            /*
            For each event add an event listener that prevents the default action
            (opening the file in the browser) and stop the propagation of the event (so
            no other elements open the file in the browser)
            */
            vm.$refs.fileform.addEventListener(evt, function(event) {
                event.preventDefault();
                event.stopPropagation();
            }.bind(vm), false);
            }.bind(vm));

            /*
                Add an event listener for drop to the form
            */
            vm.$refs.fileform.addEventListener('drop', function(event) {
                /*
                Capture the files from the drop event and add them to our local files
                array.
                */
                vm.inDragMode = false;
                if (window.FileReader) {
                    vm.input_file = event.dataTransfer.files[0];
                    vm.readFile();
                } else {
                    vm.message = {
                        msg: "Operación no soportada por este navegador!",
                        variant: "warning",
                        dismiss: 4
                    }
                }
            }.bind(this));

            vm.$refs.fileform.addEventListener('dragenter', function(event) {
                vm.inDragMode = true;
            }.bind(this));

            vm.$refs.fileform.addEventListener('dragleave', function(event) {
                vm.inDragMode = false;
            }.bind(this));

            vm.$refs.fileform.addEventListener('dragover', function(event) {
                vm.inDragMode = true;
            }.bind(this));
        }
    },
    computed: {
        getClasses: function () {
            var vm = this;
            if (vm.inDragMode) 
                return 'dragdrop dropzone';
            else {
                if (vm.input_file == '')
                    return 'dragdrop';
            }
            return '';
        }
    }
}
</script>
